import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';
import { ICustomerListData, IncidentType, IncidentTypes, IMessages } from './model';
import SdxFlyoutMenu from 'sdx/menu/MenuFlyout';
import SdxModal from 'lib/generic/SDXModalDialog';

import $ from 'jquery';

export function showInfoDialog(
	id : number,
	scn : number,
	customerName : string,
	url : string,
	labels : IMessages,
) {
	const htmlString = `
<div class="mod modPexIncidentInfoDialog"
	data-user-name="${customerName}"
	data-incident-id="${id}"
	data-incident-scn="${scn}"
	data-ajax-url="${url}"
>
	<div></div>
</div>`;
	const $html = $(htmlString);
	$html.attr('data-labels', JSON.stringify(labels));
	SdxModal.show({
		buttons: [
			{
				primary: false,
				title: labels.closeBtnLabel,
				type: 'close',
			},
		],
		class: 'pex-customer-list-detail',
		fillWidth: true,
		html: $html,
		title: labels.details,
	});
}

function IncidentList({
	data,
	labels,
	ctx,
	displayedTypes,
} : {
		data : ICustomerListData[];
		labels : IMessages;
		ctx : IncidentListRenderer;
		displayedTypes : IncidentType[];
	}) {

	const isIncidentList = displayedTypes.includes(IncidentTypes.INCIDENT);

	return <tbody>
		{data.filter(elem => elem.display)
			.map(elem => {
				return <tr
					on-mouseleave={[ctx.destroyDropdownMenu.bind(ctx)]}
				>
					<td> {elem.title} </td>
					<td> {elem.location} </td>
					{isIncidentList && (<td> {elem.customerName ? elem.customerName : '-'} </td>)}
					{isIncidentList && (<td> {elem.scn ? elem.scn : '-'} </td>)}
					<td> {elem.date} </td>
					<td className="action-buttons">
						<div className="action-menu button-group">
							<button
								className="action-button"
								attrs-data-action="dropdown-menu"
								attrs-data-toggle="flyout"
								attrs-data-target={'#customer-flyout-menu_' + elem.id}
								on-click={[ctx.initDropdownMenu.bind(ctx)]}
							>
								<i className="icon icon-053-more"></i>
							</button>
						</div>
						<div className="dropdown">
							<div
								attrs-id={'customer-flyout-menu_' + elem.id}
								className="flyout flyout--list flyout--right js-flyout"
							>
								<ul className="abstractlist">
									<li className="abstractlist-item margin-0">
										<button
											className="show-details link list-link"
											on-click={[showInfoDialog, elem.id, elem.scn, elem.customerName, ctx.ajaxUrlPrefix, labels]}
										>
											{labels.details}
										</button>
									</li>
								</ul>
							</div>
						</div>
					</td>
				</tr>;
			})}
	</tbody>;
}

export class IncidentListRenderer {
	public ajaxUrlPrefix : string;

	private target : HTMLElement | VNode;
	private data : ICustomerListData[];
	private labels : IMessages;
	private flyoutInstance : SdxFlyoutMenu | null;
	private displayedTypes : IncidentType[];

	constructor(
		target : HTMLElement,
		data : ICustomerListData[],
		labels : IMessages,
		ajaxUrlPrefix : string,
		displayedTypes : IncidentType[],
	) {
		this.target = target;
		this.data = data;
		this.flyoutInstance = null;
		this.labels = labels;
		this.ajaxUrlPrefix = ajaxUrlPrefix;
		this.displayedTypes = displayedTypes;
	}

	public render() {
		this.target = patch(
			this.target,
			<IncidentList
				data={this.data}
				labels={this.labels}
				ctx={this}
				displayedTypes={this.displayedTypes}
			/>,
		);
	}

	public clear() {
		this.target = patch(
			this.target,
			<tbody></tbody>,
		);
	}

	public initDropdownMenu(_evt : JQuery.ClickEvent, target : VNode) {
		if (this.flyoutInstance) {
			return;
		}
		this.flyoutInstance = new SdxFlyoutMenu(target.elm as HTMLElement);

		const targetId = (target.elm as HTMLElement).dataset.target;

		const $menu = $(target.elm as HTMLDocument).closest('.action-buttons').find(targetId as string);
		const $list = $menu.find('ul');

		$list.find('a, button').removeClass('flyout__indicator');

		const bottomOffset = window.innerHeight - Math.round(this.flyoutInstance.element.getBoundingClientRect().bottom);

		if ($menu.height() as number > bottomOffset) {
			$list.find('li').last().find('a, button').addClass('flyout__indicator');
			$menu.addClass('flyout--top');
			$menu.closest('.dropdown').addClass('top');
		} else {
			$list.find('li').first().find('a, button').addClass('flyout__indicator');
			$menu.removeClass('flyout--top');
			$menu.closest('.dropdown').removeClass('top');
		}

		// FIXME: This should be fixed on SDX side
		(this.flyoutInstance as any)._dynamicPlacement = false;
		this.flyoutInstance.open();
	}
	public destroyDropdownMenu() {
		if (this.flyoutInstance) {
			this.flyoutInstance.close();
			this.flyoutInstance.destroy();
			this.flyoutInstance = null;
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/IncidentListRenderer.tsx